/**
 * Search → results in the #search-lightbox, without a page load.
 *
 * Intercepts every `form.search-form` submit, fetches the results fragment
 * from admin-ajax (partials/search-results.php), injects it into
 * [data-search-results], and opens the lightbox.
 *
 * Config: window.odontiaSearch ({ url, action }) — wp_localize_script in functions.php.
 */
import { openLightbox } from '@/js/lightbox.js';

const LOADING =
	'<p class="py-4 text-body-sm text-brand-odontia-bla/60">…</p>';
const FAILED =
	'<p class="py-4 text-body-sm text-brand-odontia-bla/60">Search is unavailable right now.</p>';

function initSearch() {
	const cfg = window.odontiaSearch;
	const lightbox = document.getElementById( 'search-lightbox' );
	const results = lightbox && lightbox.querySelector( '[data-search-results]' );
	// Forms on the search results page (search.php) do a normal page load.
	const forms = [ ...document.querySelectorAll( 'form.search-form' ) ]
		.filter( ( form ) => ! form.closest( '[data-search-page]' ) );

	if ( ! cfg || ! lightbox || ! results || ! forms.length ) {
		return;
	}

	let token = 0;

	const runSearch = async ( term, trigger ) => {
		const mine = ++token;
		results.innerHTML = LOADING;
		openLightbox( lightbox, trigger );

		try {
			const url = new URL( cfg.url, window.location.origin );
			url.searchParams.set( 'action', cfg.action );
			url.searchParams.set( 's', term );

			const response = await fetch( url, { headers: { 'X-Requested-With': 'fetch' } } );
			const html = await response.text();

			if ( mine === token ) {
				results.innerHTML = response.ok ? html : FAILED;
			}
		} catch ( err ) {
			if ( mine === token ) {
				results.innerHTML = FAILED;
			}
		}
	};

	forms.forEach( ( form ) => {
		form.addEventListener( 'submit', ( event ) => {
			const input = form.querySelector( 'input[name="s"]' );
			const term = input ? input.value.trim() : '';
			if ( ! term ) {
				return; // let the browser handle an empty submit
			}
			event.preventDefault();
			runSearch( term, form.querySelector( '[type="submit"]' ) );
		} );
	} );
}

initSearch();
